import React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';

const withRouterParams = Component => {
    const ComposedComponent = ({ ...props }) => {
        return (
            <Component
                {...props}
                routerParams={useParams()}
                location={useLocation()}
                history={useHistory()}
            />
        );
    };
    return ComposedComponent;
};

export default withRouterParams;
